import React from 'react'
import { graphql } from 'gatsby'
import Wishlist from '~/components/Wishlist'
import Layout from '../layouts'

const WishlistPage = ({data}) => {
  const { markdownRemark: post, footerData, navbarData, bannerData } = data
  return(
    <Layout navbarData={navbarData} footerData={footerData} bannerData={bannerData}>
      <section className='section' style={{ minHeight: '100vh' }}>
        <div className='columns' style={{ marginTop: '2rem' }}>
          <div className='column is-12'>
            <Wishlist />
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default WishlistPage

export const wishlistPageQuery = graphql`
  query WishlistPage {
    ...LayoutFragment
  }
`
